module.exports = __webpack_public_path__ + "static/media/loader.92f9e827.gif";